import { render, staticRenderFns } from "./author-instruction.vue?vue&type=template&id=7de030d6&scoped=true&"
import script from "./author-instruction.vue?vue&type=script&lang=js&"
export * from "./author-instruction.vue?vue&type=script&lang=js&"
import style0 from "./author-instruction.vue?vue&type=style&index=0&id=7de030d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de030d6",
  null
  
)

export default component.exports